<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
  &copy; {{ year }} Vaultwarden. <br />
  {{ "versionNumber" | i18n: version }}
  <br/>
  Mon Mar 27 06:54:38 UTC 2023
  <br/>
  1258799233e9d3350b7b99767a91921fda5441d3
</div>
